module.exports = __webpack_public_path__ + "img/pinterest.a9c03a6.svg";